import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { history, store } from '../../helpers/index';
import PropTypes from 'prop-types';
import { Modal, Input, Button } from 'semantic-ui-react';
import Strings from '../../common/Strings';
import './NewOrEditProjectDialog.css';
import { projectActions } from '../../actions';

const tinycolor = require('tinycolor2');

class NewOrEditProjectDialog extends React.Component {
  constructor(props) {
    super(props);

    this.colorPickerRef = React.createRef();

    if (props.project) {
      const { project } = props;
      this.state = {
        name: project.name,
        color: project.color,
        showHoverColor: false,
        hoverColor: project.color,
        existingProjectName: false,
      };
    } else {
      this.state = {
        name: '',
        color: '#F5A623',
        showHoverColor: false,
        hoverColor: '#F5A623',
        existingProjectName: false,
      };
    }
  }

  onMouserOverColorPicker = () => {
    if (this.props.isCreatingOrUpdatingProject) return;
    this.setState({ showHoverColor: true });
  };

  onMouserOutColorPicker = () => {
    if (this.props.isCreatingOrUpdatingProject) return;
    this.setState({ showHoverColor: false });
  };

  onMouseMoveColorPicker = e => {
    if (this.props.isCreatingOrUpdatingProject) return;
    const h =
      (e.nativeEvent.offsetX / this.colorPickerRef.current.offsetWidth) * 360;
    let s =
      100 -
      (e.nativeEvent.offsetY / this.colorPickerRef.current.offsetHeight) * 100;
    const l = 50;

    if (s > 100) {
      s = 100;
    } else if (s <= 1) {
      s /= 100;
    }

    const color = tinycolor({ h, s, l });
    const hex = color.toHexString();
    this.setState({ hoverColor: hex });
  };

  onMouseUpColorPicker = () => {
    if (this.props.isCreatingOrUpdatingProject) return;
    this.setState({ color: this.state.hoverColor });
  };

  onClickCreateProject = () => {
    const { name, color } = this.state;
    const { defaultCurrency } = store.getState().user;

    if (this.projectNameExists(name, this.props.project)) {
      this.setState({ existingProjectName: true });
    } else if (this.props.project) {
      const project = { ...this.props.project };
      project.name = name;
      project.color = color;
      project.currencyCode = defaultCurrency;
      this.props.dispatch(projectActions.updateProject(project));
    } else {
      this.props.dispatch(
        projectActions.createProject(name, color, defaultCurrency),
      );
    }
  };

  handleInputChange = (e, { name, value }) => {
    this.setState({ [name]: value });
    if (this.state.existingProjectName) {
      this.setState({ existingProjectName: false });
    }
  };

  projectNameExists = (name, project) => {
    let projects = store.getState().projects.asMutable();
    if (project) {
      projects = projects.filter(p => p.id !== project.id);
    }
    return projects.find(
      p => p.name.toLowerCase().trim() === name.toLowerCase().trim(),
    );
  };

  renderProjectNameError() {
    if (this.state.existingProjectName) {
      return (
        <p id="project-create-name-error">{Strings.ERROR.projectNameExists}</p>
      );
    }
    return <div />;
  }

  render() {
    const { isCreatingOrUpdatingProject } = this.props;
    const { name, color, hoverColor } = this.state;
    const colorPickerColor = this.state.showHoverColor ? hoverColor : color;
    const buttonText = this.props.project
      ? Strings.NEW_PROJECT.saveProject
      : Strings.NEW_PROJECT.createProject;
    const createProjectNameId = this.state.existingProjectName
      ? 'create-project-name-input-error'
      : 'create-project-name-input';

    return (
      <Modal
        centered
        open
        size="tiny"
        closeIcon={!isCreatingOrUpdatingProject}
        onClose={() => {
          if (!isCreatingOrUpdatingProject) history.goBack();
        }}
      >
        <div className="new-project-modal-root">
          <div
            className="new-project-color-container"
            disabled={isCreatingOrUpdatingProject}
            onMouseOver={this.onMouserOverColorPicker}
            onMouseOut={this.onMouserOutColorPicker}
            onMouseMove={this.onMouseMoveColorPicker}
            onMouseUpCapture={this.onMouseUpColorPicker}
            ref={this.colorPickerRef}
            style={{ backgroundColor: colorPickerColor }}
          >
            <p
              className="new-project-color-hint"
              hidden={this.state.showHoverColor}
            >
              {Strings.NEW_PROJECT.colorHoverHint1}
            </p>
            <p
              className="new-project-color-hint"
              hidden={this.state.showHoverColor}
            >
              {Strings.NEW_PROJECT.colorHoverHint2}
            </p>
          </div>
          <div className="new-project-content">
            <Input
              disabled={isCreatingOrUpdatingProject}
              id={createProjectNameId}
              name="name"
              basic
              placeholder={Strings.NEW_PROJECT.nameHint}
              onChange={this.handleInputChange}
              value={name}
            />
            {this.renderProjectNameError()}
            <Button
              disabled={name.length === 0}
              id="create-project-button"
              className="common-green-button"
              onClick={this.onClickCreateProject}
              loading={isCreatingOrUpdatingProject}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

NewOrEditProjectDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isCreatingOrUpdatingProject: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isCreatingOrUpdatingProject: state.uiState.isCreatingOrUpdatingProject,
});

export default connect(mapStateToProps)(NewOrEditProjectDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/NewOrEditProjectDialog.js